/* AFORDA desktop hover navigation. Click and keyboard remain native Dawn controls. */
(() => {
  const init = () => {
    const nav = document.querySelector('.aforda-header .header__inline-menu');
    if (!nav || nav.dataset.afordaHoverReady) return;
    nav.dataset.afordaHoverReady = '1';
    const finePointer = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
    const menus = Array.from(nav.querySelectorAll('header-menu > details.mega-menu'));
    let timer;
    const closeMenu = (detail) => {
      detail.open = false;
      detail.querySelector('summary')?.setAttribute('aria-expanded', 'false');
    };
    const openMenu = (detail) => {
      clearTimeout(timer);
      menus.forEach(other => { if(other!==detail) closeMenu(other); });
      detail.open = true;
      detail.querySelector('summary')?.setAttribute('aria-expanded', 'true');
    };
    menus.forEach(detail => {
      detail.addEventListener('pointerenter', e => {
        if (finePointer.matches && e.pointerType !== 'touch') openMenu(detail);
      });
      detail.addEventListener('pointerleave', e => {
        if (!finePointer.matches || e.pointerType === 'touch') return;
        timer = setTimeout(() => {if(!detail.contains(document.activeElement)) closeMenu(detail);}, 170);
      });
      detail.querySelector('summary')?.addEventListener('focus', () => {
        if (finePointer.matches) menus.forEach(other => {if(other!==detail) closeMenu(other);});
      });
    });
    nav.querySelectorAll(':scope > .list-menu > li > a').forEach(link => {
      link.addEventListener('pointerenter', e => {if(finePointer.matches && e.pointerType !== 'touch') menus.forEach(closeMenu);});
    });
    nav.addEventListener('pointerleave', () => {
      if (!finePointer.matches) return;
      clearTimeout(timer);
      timer = setTimeout(() => menus.forEach(d => {if(!d.contains(document.activeElement)) closeMenu(d);}), 200);
    });
    document.addEventListener('keydown', e => {if(e.key==='Escape')menus.forEach(closeMenu);});
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();